export interface CheckoutCompletedOfferConfirmation {
  planNumber: string;
  breakdownStartDate: string;
  renewalDate: string;
  digitalId?: string;
}
